class ReportingEquipmentInfoInspectionsController {
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
    }

    $onInit() {
        this.unsubscribe = this.$ngRedux.connect(this.mapState, {})(this);
    }

    $onDestroy() {
        this.unsubscribe();
    }

    mapState(state) {
        return {
            equipment: state.reporting.reportingEquipmentDetails
        }
    }
}

ReportingEquipmentInfoInspectionsController.$inject = ['$ngRedux'];

export const reportingEquipmentInfoInspections = {
    controller: ReportingEquipmentInfoInspectionsController,
    template: `
        <reporting-equipment-info-inspections-grid title="{{$ctrl.equipment.title}}"></reporting-equipment-info-inspections-grid>
        <tabs-navigation identifier="app.reporting.equipmentInfo"
                         state="app.reporting.equipmentInfo.inspections">
        </tabs-navigation>
    `
};
